import React, { Component } from 'react';

const CheckBoxSection = (props) => {

    return (
        <div className="bottom-separator-xxs">
            {props.isChecked &&

            <div className="checkbox-container-view">
                
                <input type="checkbox" disabled checked={props.isChecked}></input>                  
                <p>{props.message}

                {props.value &&
                <p>{props.value + " " + props.extencion}</p>}

                </p>

                {props.subMessage &&
                    <label className="label-configuration-view">{props.subMessage}</label>}        
            </div>}     
        </div>
    );
};

export default CheckBoxSection;